import { render, staticRenderFns } from "./WorkShiftWizard.vue?vue&type=template&id=186bc4f5&scoped=true"
import script from "./WorkShiftWizard.vue?vue&type=script&lang=js"
export * from "./WorkShiftWizard.vue?vue&type=script&lang=js"
import style0 from "./WorkShiftWizard.vue?vue&type=style&index=0&id=186bc4f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186bc4f5",
  null
  
)

export default component.exports